export default __webpack_public_path__ + "static/media/whoIsItForArrow.f92e0192.svg";